import { Injectable } from '@angular/core';
import { BaseNavigationService } from './base-navigation.service';
import { NavigationService } from '../../../core/navigation/services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { MessagesType } from '../../../messages/models/enums/messages-type.enum';
import { MessagesManagementService } from '../../../messages/services/messages-management.service';

@Injectable()
export class FilesNavigationService extends BaseNavigationService {

  protected get systemQueueType() {
    return 'system_queues_files';
  }

  protected get customQueueType() {
    return 'custom_queues_files';
  }

  protected get entityTypeGrid() {
    return '.entity.files.grid';
  }

  get type() {
    return MessagesType.FILES;
  }

  constructor(protected navigationService: NavigationService,
              protected translateService: TranslateService,
              protected entityService: MessagesManagementService) {
    super(navigationService, translateService, entityService);
  }
}
